const STORAGE_KEY = 'lieu';
const ATTRIBUTE_NAME = 'data-lieu';

export { STORAGE_KEY, ATTRIBUTE_NAME };
